import { IFilterCopy } from '~types/search'

import { Radio, RadioChangeEvent } from 'antd'
import getRetailerSorts from '../useCases/getRetailerSorts'

const SortSelector = ({
  copy,
  sortOptionsConfig,
  defaultValue,
  onChangeToSort,
}: {
  copy: IFilterCopy
  sortOptionsConfig: string[]
  onChangeToSort: (value: string) => Promise<void>
  defaultValue: string
}) => {
  const options = getRetailerSorts({
    copy,
    sortOptionsConfig,
  })

  const handleChange = async (e: RadioChangeEvent) => {
    await onChangeToSort(e.target.value)
  }

  return (
    <Radio.Group
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
      defaultValue={defaultValue}
      onChange={handleChange}
      options={options}
    />
  )
}

export default SortSelector
